import React from 'react'


const String = ({value}) => {
    return value
}

export default String